import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { getRetailer } from '../../services/retailer.service';
import { useSelector } from "react-redux";

export default function RetailerDetails() {
  const { token } = useSelector((state) => state?.auth);
  const [retailer, setRetailer] = useState([]);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const retailerID = params.get("id");

  const fetchRetailer = async () => {
    try {
      const res = await getRetailer(token, retailerID);

      if (res && res.status >= 200 && res.status < 300) {
        setRetailer(res?.data);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch retailer details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching retailer:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the retailer. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (retailerID) {
      fetchRetailer();
    }
  }, [retailerID]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Retailer Details</h4>
                <Link to="/retailer">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>
              </div>
              <div className="card-body">
                <div className="row">

                  {/* Shop Name */}
                  <div className="col-sm-6 mb-4">
                    <h5>Shop Name</h5>
                    <p>{retailer.shop_name || "N/A"}</p>
                  </div>

                  {/* Retailer Name */}
                  <div className="col-sm-6 mb-4">
                    <h5>Retailer Name</h5>
                    <p>{retailer.owner_name || "N/A"}</p>
                  </div>

                  {/* Retailer Email */}
                  <div className="col-sm-6 mb-4">
                    <h5>Retailer Email</h5>
                    <p>{retailer.email || "N/A"}</p>
                  </div>

                  {/* State */}
                  {/* <div className="col-sm-6 mb-4">
                    <h5>State</h5>
                    <p>{retailer.state || "N/A"}</p>
                  </div> */}

                  {/* City */}
                  {/* <div className="col-sm-6 mb-4">
                    <h5>City</h5>
                    <p>{retailer.city || "N/A"}</p>
                  </div> */}

                  {/* Phone Number */}
                  <div className="col-sm-6 mb-4">
                    <h5>Phone Number</h5>
                    <p>{retailer.mobile || "N/A"}</p>
                  </div>

                 

                  {/* Pin Code */}
                  {/* <div className="col-sm-6 mb-4">
                    <h5>Pin Code</h5>
                    <p>{retailer.pin_code || "N/A"}</p>
                  </div> */}

                  {/* Created At */}
                  {/* <div className="col-sm-6 mb-4">
                    <h5>Created At</h5>
                    <p>{retailer.created_at || "N/A"}</p>
                  </div> */}

                  {/* GST Number */}
                  <div className="col-sm-6 mb-4">
                    <h5>GST Number</h5>
                    <p>{retailer.gst_number || "N/A"}</p>
                  </div>

                  {/* PAN Number */}
                  <div className="col-sm-6 mb-4">
                    <h5>PAN Number</h5>
                    <p>{retailer.pan_number || "N/A"}</p>
                  </div>

                   {/* Address */}
                   <div className="col-sm-12 mb-4">
                    <h5>Address</h5>
                    <p>{retailer.address || "N/A"}</p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
